import currencyXAF from '@/filters/currency.js'

export default {
  methods: {
    /**
     * Format currency in XAF
     * @param {number} value - The value to format
     * @param {boolean} showSymbol - Whether to show the XAF symbol
     * @returns {string} Formatted currency string
     */
    formatCurrency (value, showSymbol = true) {
      if (typeof value !== 'number' || isNaN(value)) {
        return '0 XAF'
      }

      if (showSymbol) {
        return currencyXAF(value)
      }

      return value.toLocaleString('en-US', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      })
    },

    /**
     * Format currency without symbol
     * @param {number} value - The value to format
     * @returns {string} Formatted number string
     */
    formatNumber (value) {
      if (typeof value !== 'number' || isNaN(value)) {
        return '0'
      }

      return value.toLocaleString('en-US', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      })
    },

    /**
     * Format percentage
     * @param {number} value - The value to format
     * @param {number} decimals - Number of decimal places
     * @returns {string} Formatted percentage string
     */
    formatPercentage (value, decimals = 1) {
      if (typeof value !== 'number' || isNaN(value)) {
        return '0%'
      }

      return value.toFixed(decimals) + '%'
    },

    /**
     * Get currency symbol
     * @returns {string} XAF symbol
     */
    getCurrencySymbol () {
      return 'XAF'
    },

    /**
     * Parse currency string to number
     * @param {string} value - The currency string to parse
     * @returns {number} Parsed number
     */
    parseCurrency (value) {
      if (typeof value === 'number') {
        return value
      }

      if (typeof value !== 'string') {
        return 0
      }

      // Remove currency symbol and commas
      const cleanValue = value.replace(/[^\d.-]/g, '')
      const parsed = parseFloat(cleanValue)

      return isNaN(parsed) ? 0 : parsed
    }
  }
}
